/**
 * SPRINT V2 — Ascenso Visual Nacional.
 * Tracks the user's nation across a 5-step ascent path. Pure derived view:
 * combines local ambassador signals + (optional) nation rank input.
 */
import { ambassadorScore, getAmbassadorState } from "./ambassador";

export type AscentStep = "tribuna" | "calentando" | "titular" | "estrella" | "leyenda";

export interface AscentSnapshot {
  nation: string | null;
  step: AscentStep;
  stepIndex: number;
  totalSteps: number;
  pctToNext: number;
  label: string;
  emoji: string;
  glow: string;
}

const STEPS: Array<{ step: AscentStep; label: string; emoji: string; glow: string; threshold: number }> = [
  { step: "tribuna",     label: "En la tribuna",  emoji: "🎟️", glow: "#94a3b8", threshold: 0   },
  { step: "calentando",  label: "Calentando",     emoji: "🔥", glow: "#22d3ee", threshold: 40  },
  { step: "titular",     label: "Titular",        emoji: "⚽", glow: "#10b981", threshold: 120 },
  { step: "estrella",    label: "Estrella",       emoji: "⭐", glow: "#facc15", threshold: 260 },
  { step: "leyenda",     label: "Leyenda",        emoji: "👑", glow: "#a855f7", threshold: 500 },
];

export function getAscentSnapshot(nation: string | null): AscentSnapshot {
  const score = ambassadorScore(getAmbassadorState(nation));
  let idx = 0;
  for (let i = STEPS.length - 1; i >= 0; i--) {
    if (score >= STEPS[i].threshold) { idx = i; break; }
  }
  const cur = STEPS[idx];
  const next = STEPS[idx + 1];
  const pctToNext = next
    ? Math.min(1, Math.max(0, (score - cur.threshold) / (next.threshold - cur.threshold)))
    : 1;
  return {
    nation,
    step: cur.step,
    stepIndex: idx,
    totalSteps: STEPS.length,
    pctToNext,
    label: cur.label,
    emoji: cur.emoji,
    glow: cur.glow,
  };
}

export function ascentSteps() { return STEPS.slice(); }